import gsap from "gsap";

let gsapInstance: any = null;

/**
 * 加载GSAP模块 - 带缓存和错误处理的异步函数
 */
export const loadGSAP = async () => {
    // 如果已经加载过GSAP，直接返回缓存的实例
    if (gsapInstance) {
        return gsapInstance;
    }

    try {
        gsapInstance = gsap;
        return gsapInstance;
    } catch (error) {
        console.error("GSAP 模块加载失败:", error instanceof Error ? error.message : "未知错误");
        throw new Error("无法加载动画库，请检查依赖安装或刷新页面");
    }
};
